<div class="grid">
    <div class="col-12 md:col-6 lg:col-3 mb-0">
        <div class="card h-full p-3 flex flex-column justify-content-between" style="height:160px;">
            <div class="flex align-items-center justify-content-between mb-3 min-w-0">
                <span class="text-900 text-xl font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis">Todas Mídias</span>
            </div>
            <div class="border-round bg-yellow-100" style="height:6px">
                <div class="h-full border-round bg-yellow-500"
                    [style.width.%]="(allPublished/(uploadCount + instagramCount + tiktokCount))*100">
                </div>
            </div>
            <div class="flex align-items-center justify-content-between mt-3 gap-2 min-w-0">
                <span class="text-900 text-md font-medium white-space-nowrap">
                    {{ uploadCount + instagramCount + tiktokCount }} Files
                </span>
                <span class="text-900 text-md font-medium white-space-nowrap">
                    {{ uploadPublished+instagramPublished+tiktokPublished }} / {{ uploadCount + instagramCount +
                    tiktokCount }}
                </span>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3 mb-0">
        <div class="card h-full p-3 flex flex-column justify-content-between" style="height:160px;">
            <div class="flex align-items-center justify-content-between mb-3 min-w-0">
                <span class="text-900 text-xl font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis">Upload</span>
                <div class="flex-shrink-0">
                    <div><img src="/assets/icons/upload_feed.jpg" class="ss-l-icons-feed"></div>
                </div>
            </div>
            <div class="border-round bg-pink-100" style="height:6px">
                <div class="h-full border-round bg-pink-500" [style.width.%]="(uploadPublished/uploadCount)*100">
                </div>
            </div>
            <div class="flex align-items-center justify-content-between mt-3 gap-2 min-w-0">
                <span class="text-900 text-md font-medium white-space-nowrap">{{ uploadCount }} Files</span>
                <span class="text-900 text-md font-medium white-space-nowrap">{{ uploadPublished }} / {{ uploadCount }}</span>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3 mb-0">
        <div class="card h-full p-3 flex flex-column justify-content-between" style="height:160px;">
            <div class="flex align-items-center justify-content-between mb-3 min-w-0">
                <span class="text-900 text-xl font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis">Instagram</span>
                <div class="flex-shrink-0"><img src="/assets/icons/instagram.webp" class="ss-l-icons-feed"></div>
            </div>
            <div class="border-round bg-instagram-light" style="height:6px">
                <!-- Barra cheia com largura dinâmica -->
                <div class="h-full border-round bg-instagram-dark"
                    [style.width.%]="(instagramPublished/instagramCount)*100">
                </div>
            </div>
            <div class="flex align-items-center justify-content-between mt-3 gap-2 min-w-0">
                <span class="text-900 text-md font-medium white-space-nowrap">{{ instagramCount }} Files</span>
                <span class="text-900 text-md font-medium white-space-nowrap">{{ instagramPublished }} / {{ instagramCount }}</span>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3 mb-0">
        <div class="card h-full p-3 flex flex-column justify-content-between" style="height:160px;">
            <div class="flex align-items-center justify-content-between mb-3 min-w-0">
                <span class="text-900 text-xl font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis">TikTok</span>
                <div class="flex-shrink-0"><img src="/assets/icons/tiktok.webp" class="ss-l-icons-feed"></div>
            </div>
            <div class="border-round bg-tiktok-light" style="height:6px">
                <div class="h-full border-round bg-tiktok-dark" [style.width.%]="(tiktokPublished/tiktokCount)*100">
                </div>
            </div>
            <div class="flex align-items-center justify-content-between mt-3 gap-2 min-w-0">
                <span class="text-900 text-md font-medium white-space-nowrap">{{ tiktokCount }} Files</span>
                <span class="text-900 text-md font-medium white-space-nowrap">{{ tiktokPublished }} / {{ tiktokCount }}</span>
            </div>
        </div>
    </div>


    <div class="col-12 md:col-5 xl:col-3">
        <div class="card h-full p-3 flex flex-column justify-content-between" style="max-height:126px !important;">
            <div class="flex align-items-center justify-content-between mb-3 min-w-0">
                <span class="text-900 text-xl font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis">Youtube</span>
                <div class="flex-shrink-0"><img src="assets/youtube-color.svg" class="ss-l-icons-feed"></div>
            </div>
            <div class="border-round bg-tiktok-light" style="height:6px">
                <div class="h-full border-round bg-tiktok-dark" [style.width.%]="(youtubePublished/youtubeCount)*100">
                </div>
            </div>
            <div class="flex align-items-center justify-content-between mt-3 gap-2 min-w-0">
                <span class="text-900 text-md font-medium white-space-nowrap">{{ youtubeCount }} Files</span>
                <span class="text-900 text-md font-medium white-space-nowrap">{{ youtubePublished }} / {{ youtubeCount }}</span>
            </div>
        </div>
        <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center"
            style="height:160px;" (click)="openModalFont()">
            <i class="pi pi-plus-circle text-3xl mb-2"></i>
            <span class="font-medium">Adicionar Feed</span>
            <span class="text-sm text-500">Selecione uma fonte para seu feed</span>
        </div>
        <div class="card">
            <div class="text-900 text-xl font-semibold mb-3">Categorias</div>
            <ul class="list-none p-0 m-0">
                <ng-container *ngIf="categoryEntries && categoryEntries.length > 0; else emptyMessage">
                    <li *ngFor="let cat of categoryEntries"
                        class="p-3 mb-3 flex align-items-center justify-content-between border-round"
                        [ngClass]="getCategoryClass(cat.key)">
                        <div class="flex align-items-center">
                            <i [ngClass]="getCategoryIcon(cat.key)" class="text-2xl mr-3"></i>
                            <span class="text-lg font-medium">{{ getCategoryLabel(cat.key) }}</span>
                        </div>
                        <span class="text-lg font-bold">{{ cat.value }}</span>
                    </li>
                </ng-container>
                <ng-template #emptyMessage>
                    <li class="text-left text-sm text-500">Sem itens publicados...</li>
                </ng-template>
            </ul>
        </div>
        <div class="card ss-l-limits-card">
            <div class="text-900 text-xl font-semibold mb-3">Limites da conta</div>
            <div class="mb-4 mt-5">
                <div class="flex justify-content-between">
                    <span class="text-900 text-md font-medium mb-3">Slicks Ativos</span>
                    <span class="text-900 text-md font-medium">{{ activeSlicksCount }}/{{ slicks_total }}</span>
                </div>
                <p-progressBar [value]="progressValue" [showValue]="false" [style]="{ height: '6px' }">
                </p-progressBar>
            </div>
            <div class="mb-4 mt-2">
                <div class="flex justify-content-between">
                    <span class="text-900 text-md font-medium mb-3">Feeds</span>
                    <span class="text-900 text-md font-medium">{{ activeFeedsCount }}/{{ feeds_total }}</span>
                </div>
                <p-progressBar [value]="progressValueFeeds" [showValue]="false" [style]="{ height: '6px' }">
                </p-progressBar>
            </div>
            <div class="mt-4 flex gap-4 ss-l-limits-actions">
                <button pButton pRipple type="button" icon="pi pi-search" label="Detalhes" pTooltip="Detalhes"
                    tooltipPosition="top" class="
                    p-button-outlined
                    flex-1 flex justify-content-center align-items-center
                    whitespace-nowrap
                    text-sm sm:text-md
                    p-button-sm
                  " (click)="showPlansDialog()"></button>
                <button pButton pRipple type="button" (click)="irParaAssinatura()" icon="pi pi-upload" label="Upgrade"
                    pTooltip="Upgrade" tooltipPosition="top" class="
                    flex-1 flex justify-content-center align-items-center
                    whitespace-nowrap
                    text-sm sm:text-md
                    p-button-sm
                  "></button>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-7 xl:col-9">
        <div class="card">
            <div class="text-900 text-xl font-semibold mb-4">
                Feeds <small class="text-sm">({{ feeds.length }})</small>
            </div>
            <div class="grid">
                <ng-container *ngIf="!isLoadingFeeds; else skeletonTemplate">
                    <div class="col-12 xl:col-4" *ngFor="let feed of feeds; trackBy: trackByFeedUid">
                        <div class="p-3 border-1 surface-border border-round relative"
                            style="min-height:100%; transition:opacity .2s" [ngClass]="{
                          'opacity-50 cursor-not-allowed': feed.status === 0 || (feed.is_connected === false && feed.feed_type === 'mentions'),
                          'hover:surface-100 cursor-pointer': feed.status === 1 && !(feed.is_connected === false && feed.feed_type === 'mentions')
                        }">
                            <!-- Linha com ícone da fonte + account selector + contador -->
                            <div class="flex align-items-center mt-1 justify-content-between mb-1">
                                <div class="flex align-items-center gap-2 overflow-hidden flex-nowrap flex-1 min-w-0">
                                    <img [src]="getFeedIcon(feed.source_id)" alt="{{ feed.title }} icon"
                                        class="object-contain" style="width: 35px; height: 35px; border-radius: 25%" />

                                    <ng-container *ngIf="feed.title !== 'Uploads'; else uploadsTitle">
                                        <div class="account-wrapper">
                                            <account-selector [source]="feed.title" [feedType]="feed.feed_type"
                                                [accountId]="feed.account_id" [channelId]="feed.channel_id ?? null"
                                                [showLabel]="false" [useAppendToBody]="true"
                                                [selectedAccountId]="feed.selectedInstagramAccount?.id"
                                                [autoload]="true"
                                                [disabled]="feed.feed_type === 'mentions'"
                                                (instagramAccountSelected)="onFeedAccountSelecionada($event, feed)">
                                            </account-selector>
                                        </div>
                                    </ng-container>

                                    <ng-template #uploadsTitle>
                                        <span class="text-900 text-lg font-medium truncate block">
                                            {{ feed.title }}
                                        </span>
                                    </ng-template>
                                </div>

                                <!-- Action Menu -->
                                <div class="relative">
                                    <!-- botão (target) -->
                                    <i #menuTarget (click)="menu.toggle($event)"
                                        class="pi pi-ellipsis-v pl-4 cursor-pointer ss-menu-btn"></i>

                                    <!-- menu com diretiva e alinhamento -->
                                    <p-menu #menu [popup]="true" [target]="menuTarget" [appendTo]="'body'"
                                        [model]="getItemActionMenu(feed)" [ssClickOutsideMenu]="menu"
                                        class="ss-g-custom-menu-right">
                                    </p-menu>
                                </div>


                            </div>

                            <!-- Chips em linha separada -->
                            <div class="flex align-items-center justify-content-between mt-2">
                                <div class="chips-scroll flex-1">
                                    <ng-container *ngIf="feed.title === 'Uploads'; else defaultChips">
                                        <p-chip class="small-chip p-chip-rounded" label="▯ stories"></p-chip>
                                        <p-chip class="small-chip p-chip-rounded" label="🗂️ personal_media"></p-chip>
                                        <p-chip class="small-chip p-chip-rounded" label="🏷 tag"></p-chip>
                                        <p-chip class="small-chip p-chip-rounded" label="#hashtag"></p-chip>
                                        <p-chip class="small-chip p-chip-rounded p-chip-uploads"
                                            label="🖼️ imagem"></p-chip>
                                        <p-chip class="small-chip p-chip-rounded p-chip-uploads"
                                            label="▶️ reel"></p-chip>
                                    </ng-container>

                                    <ng-template #defaultChips>
                                        <ng-container *ngIf="feed.feed_type">
                                            <ng-container
                                                *ngIf="feed.feed_type === 'playlist' && feed.playlist_title; else normalFeedType">
                                                <p-chip styleClass="small-chip p-chip-rounded p-chip-warning" [label]="'📋 ' + feed.playlist_title"> </p-chip>
                                            </ng-container>
                                            <ng-template #normalFeedType>
                                                <p-chip styleClass="small-chip p-chip-rounded p-chip-info"
                                                    [label]="getUnicodeIcon(feed.feed_type) + ' ' + (feed.feed_type === 'hashtag' ? '#' + feed.hastag_name : (feed.feed_type === 'tiktok_media' ? '' : feed.feed_type))">
                                                </p-chip>
                                            </ng-template>
                                        </ng-container>
                                        <ng-container *ngFor="let tag of getCleanedTags(feed)">
                                            <p-chip
                                                styleClass="small-chip p-chip-rounded p-chip-{{ getTypeSeverity(feed.type) }}"
                                                [label]="feed.title === 'YouTube'
                                                        ? '🎞️ vídeo'
                                                        : getUnicodeIcon(tag) + ' ' + (tag.trim().toLowerCase() === 'image' ? 'imagem' : tag.trim().toLowerCase())
                                                    ">
                                            </p-chip>
                                        </ng-container>
                                    </ng-template>


                                </div>
                                <!-- Contador -->
                                <span class="text-600 text-md font-semibold flex-shrink-0 ml-2">
                                    <span class="text-xl">{{ feed.published_count }}</span>/{{ feed.published_count +
                                    feed.unpublished_count }}
                                </span>
                            </div>

                            <!-- SSAPP-7/SSAPP-22: resumo dos filtros avançados, quando o feed tem algum
                                configurado — scroll lateral (mesmo padrão da linha de tipo de mídia
                                acima), sem truncar por quantidade de grupos -->
                            <div class="flex align-items-center gap-1 mt-2 min-w-0" *ngIf="hasFeedFilters(feed)">
                                <i class="pi pi-filter text-500 text-xs flex-shrink-0 cursor-pointer"
                                    pTooltip="Editar filtros" tooltipPosition="top"
                                    (click)="onEditFilters(feed)"></i>
                                <div class="chips-scroll flex-1">
                                    <p-chip *ngFor="let chipLabel of getFeedFilterChips(feed)"
                                        styleClass="small-chip p-chip-rounded" [label]="chipLabel"></p-chip>
                                </div>
                            </div>

                        </div>
                    </div>
                </ng-container>
                <ng-template #skeletonTemplate>
                    <div class="col-12 md:col-6 xl:col-4" *ngFor="let sk of skeletonArray">
                        <div class="p-3 border-1 surface-border border-round"
                            style="min-height:100%; transition:opacity .2s;height: 100px;">
                            <div class="flex align-items-start justify-content-between mb-2">
                                <div class="flex align-items-center flex-1 min-w-0">
                                    <div class="flex-none w-2 h-2 mr-3 flex align-items-center justify-content-center">
                                        <p-skeleton width="100%" height="100%" styleClass="border-round"></p-skeleton>
                                    </div>
                                    <div class="flex flex-column flex-1 min-w-0">
                                        <p-skeleton width="60%" height="1.5rem" class="mb-2"></p-skeleton>
                                        <div class="overflow-x-auto whitespace-nowrap flex-1 min-w-0"
                                            style="white-space: nowrap;">
                                            <p-skeleton width="40px" height="1rem" class="mr-2"></p-skeleton>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex flex-column align-items-end flex-shrink-0 ml-2">
                                    <p-skeleton width="1.5rem" height="1.5rem" shape="circle"></p-skeleton>
                                    <p-skeleton width="30px" height="1rem" class="mt-2"></p-skeleton>
                                </div>

                            </div>

                        </div>
                    </div>
                </ng-template>
            </div>
            <div class="text-center mt-4" *ngIf="nextCursor">
                <button pButton pRipple label="Carregar mais" (click)="loadFeeds()">
                </button>
            </div>
        </div>
        <div class="card p-4">
            <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-3">
                <h3 class="text-900 text-xl font-semibold w-full md:w-auto mb-2 md:mb-0">
                    Ingests recentes
                </h3>


            </div>
            <p-table #dt [value]="recentIngests" [globalFilterFields]="['name','source_id']" [paginator]="true"
                [rows]="10" class="w-full">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="text-center">Descrição</th>
                        <th class="text-center">Fonte</th>
                        <th class="text-center">Status</th>
                        <th class="text-center">Ações</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-ingest let-rowIndex="rowIndex">
                    <tr>
                        <td class="text-center max-caption-cell">
                            <div class="caption-text">{{ ingest.caption || ingest.description }}</div>
                        </td>
                        <td class="text-center">
                            <p-chip class="ss-l-pchip" [label]="mapSourceLabel(ingest.feed_source_title)"
                                [image]="getSourceIcon(ingest.feed_source_title)"
                                [styleClass]="'p-chip-rounded p-chip-'+ getSourceSeverity(ingest.feed_source_title)">
                            </p-chip>
                        </td>
                        <td class="text-center">
                            <p-chip [label]="ingest.status === 1 ? 'Publicado' : 'Não publicado'"
                                [styleClass]="'p-chip-rounded p-chip-' + getStatusSeverity(ingest.status)">
                            </p-chip>
                        </td>
                        <td class="text-center">
                            <button pButton type="button" icon="pi pi-pencil" class="p-button-text mr-2"
                                aria-label="Editar" [routerLink]="['/slick', ingest.uniq_id]">
                            </button>
                            <p-inputSwitch [ngModel]="ingest.isPublished"
                                (ngModelChange)="onTogglePublish(ingest, $event, rowIndex)"
                                aria-label="Publicar/Inativar">
                            </p-inputSwitch>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="4" class="p-4">
                            <div class="flex flex-column align-items-center justify-content-center text-center gap-2">
                                <i class="pi pi-inbox text-4xl text-500"></i>
                                <span class="font-medium text-600">Nada por aqui ainda</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-dialog header="Plano Assinado" [(visible)]="displayPlans" [modal]="true" [dismissableMask]="true" [closable]="true"
    styleClass="dialog1" (onHide)="closePlansDialog()" appendTo="body">
    <div class="grid mt-1">
        <div *ngIf="userSubType === 0" class="col-12 p-2 pricing-card">
            <div class="card border-1 surface-border border-round p-5 flex flex-column h-full">
                <h3 class="text-900 text-xl font-medium mb-2">Free</h3>
                <p class="text-600">Plano gratuito com recursos básicos</p>
                <div class="my-4 border-top-1 border-300"></div>
                <div class="flex align-items-center">
                    <span class="text-900 font-bold text-2xl">$0</span>
                    <span class="text-600 ml-2">por mês</span>
                </div>
                <div class="my-4 border-top-1 border-300"></div>
                <ul class="list-none p-0 flex-grow-1">
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Integração com Shopify
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Vídeos em todas as páginas do site
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Widgets disponíveis: stories, carrossel, popup, grid e inline
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Compartilhamento via redes sociais ou links específicos
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Dashboard com métricas de performance (Analytics)
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Até {{free_plan_videos_count}} vídeos
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        até {{free_plan_views_count}} views
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Suporte via e-mail
                    </li>
                </ul>
            </div>
        </div>
        <div *ngIf="userSubType === 1" class="col-12 p-2 pricing-card">
            <div class="card border-1 surface-border border-round p-5 flex flex-column h-full">
                <h3 class="text-900 text-xl font-medium mb-2">Starter</h3>
                <p class="text-600">Plano para pequenos negócios</p>
                <div class="my-4 border-top-1 border-300"></div>
                <div class="flex align-items-center">
                    <span class="text-900 font-bold text-2xl">{{starterPlanPrice}}</span>
                    <span class="text-600 ml-2">por mês</span>
                </div>
                <div class="my-4 border-top-1 border-300"></div>
                <ul class="list-none p-0 flex-grow-1">
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Integração com Shopify
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Vídeos em todas as páginas do site
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Widgets disponíveis: stories, carrossel, popup, grid e inline
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Compartilhamento via redes sociais ou links específicos
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Dashboard com métricas de performance (Analytics)
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Até {{starter_plan_videos_count}} vídeos
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        até {{starter_plan_views_count}} views
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        R${{starterPlanViews}}/view adicional
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Suporte via whatsapp
                    </li>
                </ul>
            </div>
        </div>
        <div *ngIf="userSubType === 2" class="col-12 p-2 pricing-card">
            <div class="card border-1 surface-border border-round p-5 flex flex-column h-full">
                <h3 class="text-xl font-medium mb-2">Pro</h3>
                <p class="text-600">Plano completo para empresas</p>
                <div class="my-4 border-top-1 border-300"></div>
                <div class="flex align-items-center">
                    <span class="font-bold text-2xl">{{proPlanPrice}}</span>
                    <span class="text-600 ml-2">por mês</span>
                </div>
                <div class="my-4 border-top-1 border-300"></div>
                <ul class="list-none p-0 flex-grow-1">
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Integração com Shopify
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Vídeos em todas as páginas do site
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Widgets disponíveis: stories, carrossel, popup, grid e inline
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Compartilhamento via redes sociais ou links específicos
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Dashboard com métricas de performance (Analytics)
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Até {{pro_plan_videos_count}} vídeos
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        até {{pro_plan_views_count}} views
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        R${{proPlanViews}}/view adicional
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Suporte via whatsapp
                    </li>
                </ul>
            </div>
        </div>
        <div *ngIf="userSubType === 3" class="col-12 p-2 pricing-card">
            <div class="card border-1 surface-border border-round p-5 flex flex-column h-full">
                <h3 class="text-900 text-xl font-medium mb-2">Enterprise</h3>
                <p class="text-600">Solução personalizada para grandes empresas</p>
                <div class="my-4 border-top-1 border-300"></div>
                <div class="flex align-items-center">
                    <span class="text-900 font-bold text-2xl">{{enterprisePlanPrice}}</span>
                    <span class="text-600 ml-2">por mês</span>
                </div>
                <div class="my-4 border-top-1 border-300"></div>
                <ul class="list-none p-0 flex-grow-1">
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Integração com Shopify
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Vídeos em todas as páginas do site
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Widgets disponíveis: stories, carrossel, popup, grid e inline
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Compartilhamento via redes sociais ou links específicos
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Dashboard com métricas de performance (Analytics)
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Até {{enterprise_plan_videos_count}} vídeos
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        até {{enterprise_plan_views_count}} views
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        R${{enterprisePlanViews}}/view adicional
                    </li>
                    <li class="flex align-items-center mb-3">
                        <i class="pi pi-check-circle text-primary mr-2"></i>
                        Suporte via call
                    </li>
                </ul>
            </div>
        </div>
    </div>
</p-dialog>

<!-- <p-toast position="top-right"></p-toast> -->


<app-dialog-aguarde [visible]="displayAguarde"></app-dialog-aguarde>

<p-sidebar [(visible)]="showGaleriaSidebar" [modal]="!isMobile" (onHide)="closeGaleria()"
    class="ss-g-custom-sidebar-width ss-l-class-metaApp" position="right">
    <ng-template pTemplate="header">
        <h4 class="mb-0">Adicionar Feed</h4>
    </ng-template>
    <app-feed-help [text]="'Feeds'" class="" [videoUrl]="'https://youtube.com/video-tutorial'"
        [supportUrl]="'https://meusite.com/suporte'">
    </app-feed-help>
    <app-galeria [source]="feedSource" [isFeed]="true" [enablePanelAdjustment]="false" [showContent]="showContent"
        (hashtagResults)="onHashTagJson($event)" (tagsResults)="onTagsJson($event)" (mediaResults)="onMediaJson($event)"
        (storiesResults)="onStoriesJson($event)"></app-galeria>
    <app-feed-filter-builder *ngIf="!galeria?.showConectAccount" [disabled]="loadingSearch" [loading]="loadingSearch"
        [open]="showGaleriaSidebar" (filtersChange)="currentFeedFilters = $event"
        (validityChange)="feedFiltersValid = $event">
    </app-feed-filter-builder>
    <div class="mt-4"></div>
    <p-message *ngIf="!galeria?.showConectAccount" class="mt-4" severity="warn" icon="pi pi-send"
        text="Ao criar um Feed, apenas as 50 mídias mais recentes serão prontamente adicionadas. Depois disso, todas as mídias subsequentes serão adicionadas ao Feed a cada 24h.">

    </p-message>
    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple label="Fechar" (click)="closeGaleria()" class="p-button-outlined "></button>
            <button pButton pRipple label="Adicionar" [loading]="loadingSearch" [disabled]="!canAddFeed"
                (click)="addFeed()" class="ml-2 mr-2"></button>

        </div>
    </ng-template>
</p-sidebar>
<p-dialog [(visible)]="showSelectFont" [modal]="true" [closable]="true" [dismissableMask]="true" styleClass="dialog1"
    appendTo="body">
    <ng-template pTemplate="header">
        <div class="flex justify-content-between align-items-center w-full">
            <div>
                <h3 class="m-0">Selecione uma fonte</h3>
                <p class="m-0 text-sm">Selecione uma fonte para alimentar seu feed de <strong>slicks®</strong></p>
            </div>

        </div>
    </ng-template>
    <div class="flex justify-content-center align-items-center gap-3 border-1 border-dashed border-round p-3 ss-btn-font"
        style="height: 125px;">
        <button pButton (click)="openGaleria('instagram')" icon="pi pi-instagram"
            class="p-button-rounded p-button-secondary ss-btn-font" style="height: 3rem !important;"></button>


        <button pButton (click)="openGaleria('tiktok')" icon="bi bi-tiktok"
            class="p-button-rounded p-button-secondary ss-btn-font" style="height: 3rem !important;"></button>

        <button pButton (click)="openGaleria('google')" icon="bi bi-youtube"
            class="p-button-rounded p-button-secondary ss-btn-font" style="height: 3rem !important;"></button>

    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Fechar" (click)="showSelectFont = false" class="p-button-outlined"></button>
    </ng-template>
</p-dialog>
<app-upgrade-dialog [(visible)]="showUpgradeDialog" [title]="upgradeDialogTitle" [message]="upgradeDialogMessage"
    (close)="showUpgradeDialog = false" (upgrade)="irParaAssinatura()">
</app-upgrade-dialog>

<!-- SSAPP-7: edição dos filtros avançados de um feed já criado -->
<p-dialog [(visible)]="editFiltersVisible" [modal]="true" [closable]="true" [dismissableMask]="true"
    [style]="{width: '500px'}" (onHide)="cancelEditFilters()">
    <ng-template pTemplate="header">
        <h4 class="m-0">Editar filtros — {{ editFiltersFeed?.title }}</h4>
    </ng-template>
    <app-feed-filter-builder [disabled]="editFiltersSaving" [loading]="editFiltersSaving"
        [open]="editFiltersVisible" [initialFilters]="editFiltersFeed?.filters"
        (filtersChange)="editFiltersDraft = $event" (validityChange)="editFiltersValid = $event">
    </app-feed-filter-builder>
    <ng-template pTemplate="footer">
        <div class="w-full text-right">
            <button pButton label="Cancelar" class="p-button-outlined mr-2" [disabled]="editFiltersSaving"
                (click)="cancelEditFilters()"></button>
            <button pButton label="Salvar" [loading]="editFiltersSaving" [disabled]="!editFiltersValid"
                (click)="saveFeedFilters()"></button>
        </div>
    </ng-template>
</p-dialog>